import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  Link,
  Typography,
} from '@mui/material';
import { SCRIVE_TYPE } from '@treyd-io/core/constants/auth';
import { useTimer } from '@treyd-io/core/hooks/useTimer';
import { OtpField } from '@treyd-io/treyd-ui/components/OtpField';
import { Form, Formik, FormikHelpers } from 'formik';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

export interface OtpFormData {
  otp: string;
}

export interface Props {
  onSubmit: (
    values: OtpFormData,
    formikHelpers: FormikHelpers<OtpFormData>
  ) => void;
  onBackClick: () => void;
  onResend: () => void;
  loading: boolean;
  type: SCRIVE_TYPE;
}

export const OtpBody = (props: Props) => {
  const { onSubmit, onBackClick, onResend, loading, type } = props;
  const { t } = useTranslation();
  const { counter, startTimer } = useTimer(0, 30);

  const VALIDATION_SCHEMA = yup.object({
    otp: yup.string().required(t('otp_required')).min(6, t('otp_required')),
  });

  const handleOtpSubmit = (
    values: OtpFormData,
    formikHelpers: FormikHelpers<OtpFormData>
  ) => {
    onSubmit(values, formikHelpers);
  };
  return (
    <Formik
      initialValues={{
        otp: '',
      }}
      onSubmit={handleOtpSubmit}
      validationSchema={VALIDATION_SCHEMA}
      validateOnMount>
      {(formik) => {
        return (
          <Form noValidate>
            <DialogContent>
              <Typography color="text.secondary" variant="body1">
                {t('otp_dialog_description')}
              </Typography>
              <Box marginTop={3}>
                <OtpField
                  value={formik.values.otp}
                  TextFieldsProps={{ placeholder: '0' }}
                  onChange={(value) => formik.setFieldValue('otp', value)}
                />
                <Typography marginTop={2} color="info.main" variant="body1">
                  {t('did_not_receive_code')}{' '}
                  <Link
                    component={'button'}
                    type="button"
                    disabled={!!counter}
                    sx={{
                      cursor: 'pointer',
                      color: counter ? 'text.disabled' : 'info.main',
                    }}
                    onClick={() => {
                      startTimer();
                      onResend();
                    }}>
                    {t('resend')} {Boolean(counter) && `(${counter})`}
                  </Link>
                </Typography>
              </Box>
            </DialogContent>
            <DialogActions
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column-reverse', sm: 'row' },
                gap: { xs: 2, sm: 0 },
              }}>
              <Button
                variant="outlined"
                color="secondary"
                size="large"
                type="button"
                onClick={onBackClick}>
                {t('back')}
              </Button>
              <Button
                size="large"
                loading={formik.isSubmitting || loading}
                disabled={!formik.isValid}
                type="submit"
                variant="contained">
                {type === SCRIVE_TYPE.SIGN && t('sign')}
                {type === SCRIVE_TYPE.AUTH && t('confirm')}
              </Button>
            </DialogActions>
          </Form>
        );
      }}
    </Formik>
  );
};
